import React, { forwardRef } from 'react'
import { Link as RouterLink } from 'react-router-dom'

export interface NextLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: any
  as?: string
  replace?: boolean
  scroll?: boolean
  shallow?: boolean
  passHref?: boolean
  prefetch?: boolean
  locale?: string | false
  legacyBehavior?: boolean
  children?: React.ReactNode
}

const Link = forwardRef<HTMLAnchorElement, NextLinkProps>(function NextLinkCompat(
  { href, as, replace, scroll, shallow, passHref, prefetch, locale, legacyBehavior, children, ...rest },
  ref
) {
  const to =
    typeof href === 'object' && href !== null
      ? (href.pathname || '/') + (href.query ? `?${new URLSearchParams(href.query).toString()}` : '')
      : href || '/'

  if (legacyBehavior && React.isValidElement(children)) {
    return React.cloneElement(children as React.ReactElement<any>, {
      href: to,
      onClick: (e: React.MouseEvent) => {
        ;(children.props as any)?.onClick?.(e)
      }
    })
  }

  return (
    <RouterLink ref={ref} to={to} replace={replace} {...rest}>
      {children}
    </RouterLink>
  )
})

export default Link
